

import React, { memo } from 'react';
import BooleanValueAddon from '../../components/BooleanValueAddon';












function VoiceOverArtist({
  voiceOverArtist,
  onChangeAddon,
  disabled,
  VOICE_OVER_ARTIST,
  onInfoClick,
  editingMode,
  getBillingEntityCode,
  showAboutInfo
}) {
  const subtitle = `Professional voice. ${editingMode ? 'Enter billed amount in USD.' : 'Allow up to 48 hours.'} `;

  return (
    <BooleanValueAddon
      name="VOICE_OVER_ARTIST"
      options={VOICE_OVER_ARTIST}
      addonValue={voiceOverArtist}
      title="Voice Over Artist"
      subtitle={subtitle}
      icon="voiceover"
      onChangeAddon={onChangeAddon('VOICE_OVER_ARTIST')}
      disabled={disabled}
      withInfo
      onInfoClick={onInfoClick}
      costPreffix="From"
      editingMode={editingMode}
      getBillingEntityCode={getBillingEntityCode}
      showAboutInfo={showAboutInfo} />);


}

export default memo(VoiceOverArtist);